import React from 'react';
const cuadernillos = [{
  icon: '📘',
  title: 'TOMO 1 — EL ARQUITECTO CURRICULAR',
  desc: 'Planificación Anual y Mensual con IA. Prompts 100% copiables alineados al NAP y al diseño curricular de tu provincia. Para Primaria y Secundaria.'
}, {
  icon: '📘',
  title: 'TOMO 2 — EL CREATIVO DE AULA',
  desc: 'Secuencias Didácticas y Clases que Enganchan. Estrategias activas (ABP, debate, gamificación). Proyectos interdisciplinarios y actos escolares.'
}, {
  icon: '📘',
  title: 'TOMO 3 — EL AUDITOR DE NOTAS',
  desc: 'Evaluaciones, Rúbricas y Correcciones. Exámenes con solucionario, rúbricas analíticas y sistema de corrección que reduce el tiempo a la mitad.'
}, {
  icon: '📘',
  title: 'TOMO 4 — EL ESCUDO ADMINISTRATIVO',
  desc: 'Informes, Actas y Burocracia Institucional. Informes pedagógicos trimestrales, notas formales, actas de reunión y comunicados institucionales.'
}, {
  icon: '📘',
  title: 'TOMO 5 — EL FACILITADOR DE INCLUSIÓN',
  desc: 'PPI, Adecuaciones y Educación Inclusiva. Propuestas Pedagógicas Individuales completas alineadas a Res. CFE 311/16 para TEA, TDAH y más.'
}];
export function CuadernillosDetail() {
  return <section className="pt-6 md:pt-10 pb-10 md:pb-16 px-4 bg-brand-dark" data-id="element-62">
      <div className="max-w-4xl mx-auto" data-id="element-63">
        <div className="text-center mb-6 md:mb-12" data-id="element-64">
          <h2 className="text-4xl font-black text-white mb-3 md:mb-4" data-id="element-65">
            📦 ¿QUÉ INCLUYE EL SISTEMA?
          </h2>
          <div className="inline-block bg-brand-blue text-white font-bold px-6 py-2 rounded-lg text-xl" data-id="element-66">
            📚 300 módulos · 5 tomos · 120+ prompts
          </div>
          <p className="text-xl text-gray-400 mt-3 md:mt-4 font-medium" data-id="element-67">
            Listo para usar todo el año — Primaria y Secundaria
          </p>
        </div>

        <div className="space-y-3 md:space-y-5" data-id="element-68">
          {cuadernillos.map((c, i) => <div key={i} className="bg-white/5 border-2 border-white/10 p-4 md:p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow flex flex-col md:flex-row gap-4 md:gap-6 items-start" data-id="element-69">
              <div className="text-5xl md:text-6xl flex-shrink-0" data-id="element-70">{c.icon}</div>
              <div data-id="element-71">
                <h3 className="text-2xl font-bold text-white mb-3" data-id="element-72">
                  {c.title}
                </h3>
                <p className="text-lg text-gray-300 leading-relaxed" data-id="element-73">
                  {c.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}